module.exports = __webpack_public_path__ + "img/annotation-info.960b3f35.svg";